<template>
  <div
    v-if="checklists"
    v-loading="loading"
  >
    <div class="flex justify-between items-center px-2 my-2">
      <div class="fs-16 fw-600 txt-grey-900">Xét nghiệm, CLS</div>
      <div class="flex items-center space-x-3">
        <div class=" text-gray-800">
          <el-dropdown
            trigger="click"
            placement="bottom"
            @command="switchView"
          >
            <el-button
              type="text"
              size="medium"
            ><svg
                class="-mt-0.5 mr-1"
                width="17"
                height="17"
                viewBox="0 0 17 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.975 13.8043L14.4282 13.8241C14.605 13.8251 14.775 13.7558 14.9007 13.6315C15.0265 13.5072 15.0977 13.338 15.0987 13.1612C15.0997 12.9844 15.0304 12.8144 14.9061 12.6887C14.7818 12.563 14.6127 12.4918 14.4359 12.4907L10.9826 12.471C10.8446 12.0841 10.5909 11.7491 10.2559 11.5114C9.92094 11.2737 9.52088 11.145 9.11014 11.1426C8.6994 11.1403 8.2979 11.2644 7.9602 11.4983C7.6225 11.7321 7.36498 12.0642 7.22264 12.4495L2.43605 12.4221C2.25924 12.4211 2.08927 12.4904 1.96354 12.6147C1.8378 12.739 1.76659 12.9082 1.76558 13.085C1.76457 13.2618 1.83384 13.4317 1.95814 13.5575C2.08245 13.6832 2.25162 13.7544 2.42842 13.7554L7.21501 13.7828C7.35294 14.1697 7.60664 14.5048 7.94165 14.7424C8.27665 14.9801 8.67671 15.1088 9.08745 15.1112C9.49819 15.1135 9.89969 14.9894 10.2374 14.7555C10.5751 14.5217 10.8326 14.1896 10.975 13.8043ZM8.43214 13.1231C8.43289 12.9912 8.47273 12.8626 8.54661 12.7534C8.62049 12.6441 8.72509 12.5593 8.8472 12.5095C8.9693 12.4598 9.10342 12.4473 9.23259 12.4738C9.36176 12.5003 9.48019 12.5644 9.57289 12.6582C9.66559 12.752 9.7284 12.8711 9.75338 13.0006C9.77837 13.13 9.7644 13.264 9.71324 13.3855C9.66209 13.5071 9.57605 13.6107 9.466 13.6833C9.35595 13.756 9.22683 13.7943 9.09498 13.7936C8.91817 13.7925 8.74901 13.7213 8.6247 13.5956C8.50039 13.4699 8.43113 13.2999 8.43214 13.1231ZM7.0017 9.11484L14.4549 9.15747C14.6317 9.15848 14.8017 9.08921 14.9274 8.96491C15.0532 8.8406 15.1244 8.67143 15.1254 8.49463C15.1264 8.31782 15.0571 8.14785 14.9328 8.02211C14.8085 7.89637 14.6393 7.82517 14.4625 7.82416L7.00933 7.78153C6.8714 7.39463 6.6177 7.05959 6.2827 6.82192C5.94769 6.58426 5.54764 6.4555 5.1369 6.45315C4.72616 6.4508 4.32466 6.57497 3.98695 6.80879C3.64925 7.04261 3.39173 7.37473 3.24939 7.76003L2.46274 7.75553C2.28593 7.75452 2.11596 7.82378 1.99022 7.94809C1.86449 8.0724 1.79328 8.24156 1.79227 8.41837C1.79126 8.59518 1.86053 8.76515 1.98483 8.89089C2.10914 9.01662 2.2783 9.08783 2.45511 9.08884L3.24177 9.09334C3.37969 9.48024 3.6334 9.81528 3.9684 10.0529C4.3034 10.2906 4.70346 10.4194 5.1142 10.4217C5.52494 10.4241 5.92644 10.2999 6.26414 10.0661C6.60184 9.83226 6.85936 9.50014 7.0017 9.11484ZM4.45889 8.43362C4.45965 8.30177 4.49948 8.1731 4.57336 8.06389C4.64724 7.95468 4.75185 7.86983 4.87395 7.82007C4.99606 7.77031 5.13018 7.75787 5.25935 7.78433C5.38852 7.8108 5.50694 7.87497 5.59964 7.96873C5.69234 8.0625 5.75515 8.18165 5.78014 8.31112C5.80512 8.44058 5.79115 8.57455 5.74 8.69608C5.68884 8.8176 5.6028 8.92123 5.49275 8.99386C5.3827 9.06648 5.25359 9.10485 5.12174 9.10409C4.94493 9.10308 4.77576 9.03187 4.65146 8.90614C4.52715 8.7804 4.45788 8.61043 4.45889 8.43362ZM12.3616 4.47875L14.4816 4.49088C14.6584 4.49189 14.8284 4.42262 14.9541 4.29832C15.0799 4.17401 15.1511 4.00484 15.1521 3.82804C15.1531 3.65123 15.0838 3.48126 14.9595 3.35552C14.8352 3.22978 14.666 3.15858 14.4892 3.15757L12.3693 3.14544C12.2313 2.75855 11.9776 2.4235 11.6426 2.18583C11.3076 1.94817 10.9076 1.81941 10.4968 1.81706C10.0861 1.81471 9.68459 1.93888 9.34689 2.1727C9.00919 2.40652 8.75167 2.73865 8.60933 3.12394L2.48943 3.08894C2.31262 3.08793 2.14265 3.15719 2.01691 3.2815C1.89118 3.40581 1.81997 3.57497 1.81896 3.75178C1.81795 3.92859 1.88721 4.09856 2.01152 4.2243C2.13583 4.35003 2.30499 4.42124 2.4818 4.42225L8.6017 4.45725C8.73963 4.84415 8.99333 5.1792 9.32833 5.41686C9.66334 5.65453 10.0634 5.78328 10.4741 5.78563C10.8849 5.78798 11.2864 5.66381 11.6241 5.42999C11.9618 5.19617 12.2193 4.86405 12.3616 4.47875ZM9.81883 3.79753C9.81958 3.66568 9.85942 3.53701 9.9333 3.4278C10.0072 3.31859 10.1118 3.23374 10.2339 3.18398C10.356 3.13422 10.4901 3.12178 10.6193 3.14824C10.7485 3.17471 10.8669 3.23888 10.9596 3.33265C11.0523 3.42641 11.1151 3.54556 11.1401 3.67503C11.1651 3.80449 11.1511 3.93846 11.0999 4.05999C11.0488 4.18151 10.9627 4.28514 10.8527 4.35777C10.7426 4.43039 10.6135 4.46876 10.4817 4.468C10.3049 4.46699 10.1357 4.39578 10.0114 4.27005C9.88708 4.14431 9.81782 3.97434 9.81883 3.79753Z"
                  fill="currentColor"
                />
              </svg>
              {{ textModeView }}</el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(option, index) in options"
                :key="index + 'modeView'"
                :command="option"
              >
                <span>{{option.label}}</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div
          class="text-base text-gray-800 cursor-pointer bg-blue-50 text-center rounded w-6 h-6"
          @click="addIndication"
        >
          <i class="el-icon-plus"></i>
        </div>
      </div>
    </div>

    <div class="h-item-scroll">
      <div
        class="checklist-item"
        v-for="checklist in checklists"
        :key="'ckl' + checklist.id"
      >
        <div
          :id="'checklist_' + checklist.id"
          class="mt-1 mr-1"
        >
          <div
            class="d-flex cursor-pointer"
            @click="viewDetailIndication(checklist.id)"
          >
            <div class="mr-2 text-lg flex justify-center items-center checklist-icon">
              <div
                class="checklist-icon rounded-full"
                :class="getNameClass(checklist.status)"
              ></div>
            </div>
            <p class="fs-13 fw-500 txt-grey-900 mb-0 text-justify">
              {{ checklist.name || checklist.test_result_name }}
            </p>
          </div>
          <div
            v-if="checklist.indication_order"
            class="flex justify-end items-center mt-1"
          >
            <div
              class="fs-12 font-semibold text-primary cursor-pointer"
              @click="viewDetailList(checklist.indication_order)"
            >
              {{ checklist.indication_order.name }}
            </div>
          </div>
          <div
            class="fs-13 font-medium mt-2"
            v-if="checklist.examination_results"
          >Kết luận:
            <span v-if="checkType(checklist) === 1">
              <!-- <span
                v-for="(test_values, i) in checklist.examination_results.test_values"
                :key="i+'test_values'"
              >
            </span> -->
            </span>
            <span v-if="checkType(checklist) === 2">
              <span>
                {{ checklist.examination_results.conclusion && checklist.examination_results.conclusion.conclusion }}
              </span>
            </span>
          </div>
          <div
            class="flex mt-1 items-center"
            :class="checklist.due_date ? 'justify-between' : ''"
          >
            <div class="flex items-center space-x-2">
              <el-tooltip
                class="item"
                effect="dark"
                :content="getDataDemo(checklist.target_id)"
                placement="bottom"
              >
                <div
                  :class="checklist.target_id ? 'text-green-600 bg-blue-50' : 'text-gray-800 bg-white border-item-dashed'"
                  class="text-sm  cursor-pointer rounded-full flex justify-center items-center w-8 h-8"
                >
                  <div><i class="el-icon-map-location"></i></div>
                </div>
              </el-tooltip>
              <div
                v-if="!checklist.due_date"
                class="text-sm text-gray-800 cursor-pointer border-item-dashed rounded-full flex justify-center items-center w-8 h-8"
              >
                <div><i class="el-icon-date"></i></div>
              </div>
              <div v-else>{{ formatDMY(checklist.due_date) }}</div>
            </div>
            <el-dropdown
              trigger="click"
              placement="bottom"
              @command="setValueStatus"
              :disabled="!checklist.status"
            >
              <el-button
                class="btn-dropdown"
                :disabled="!checklist.status"
              >
                <div class="fs-12 w-full">
                  <span>{{ checklist.valueStatus }}</span>
                  <span><i class="el-icon-arrow-down el-icon--right"></i></span>
                </div>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="(option, index) in optionsStatus"
                  :key="index + 'status'"
                  :command="setOptionStatus(option, checklist.id)"
                >
                  <span>{{ option.label }}</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
      <div
        class="flex justify-center items-center my-3 mr-2.5"
        @click="addIndication"
      >
        <el-button
          icon="el-icon-plus"
          size="small"
        >Phiếu chỉ định</el-button>
      </div>
    </div>

    <ModalIndication
      ref="ModalIndication"
      :mr_id="$route.params.id"
      @refresh="getIndicationsByMR"
    />
    <ModalDetailIndication
      ref="ModalDetailIndication"
      @refresh="getIndicationsByMR"
    />
  </div>
</template>

<script>
import ModalIndication from '../../../../components/Indications/ModalCreateIndicationOrder.vue'
import ModalDetailIndication from './ModalDetailIndication.vue'
import dataDemo from './ModalIndication/dataMemo'
import moment from 'moment'
export default {
  name: 'IndicationsState',
  components: { ModalIndication, ModalDetailIndication },
  data () {
    return {
      dataState: [],
      loading: false,
      mode: 1,
      textModeView: 'Tất cả',
      dataDemo,
      options: [{
        value: 1,
        label: 'Tất cả'
      }, {
        value: 2,
        label: 'Đang xử lý'
      }, {
        value: 3,
        label: 'Đã xem'
      }],
      optionsStatus: [{
        value: 1,
        label: 'Chưa nhận xét'
      }, {
        value: 2,
        label: 'Clinical Signification'
      }, {
        value: 3,
        label: 'Non Clinical Signification'
      }]
    }
  },
  watch: {
    '$refresh' () {
      this.getIndicationsByMR()
    }
  },
  mounted () {
    this.getIndicationsByMR()
  },
  computed: {
    checklists () {
      return this.dataState.filter(item => {
        if (this.mode === 2) return !(item.status === 2 || item.status === 3)
        else if (this.mode === 3) return (item.status === 2 || item.status === 3)
        else return item
      })
    }
  },
  methods: {
    viewDetailIndication (id) {
      console.log('viewDetailIndication')
      this.$refs.ModalDetailIndication.openDialog(id)
    },
    viewDetailList (indication_order) {
      this.$refs.ModalIndication.openDialog('detail', indication_order)
    },
    addIndication () {
      console.log('addIndication')
      this.$refs.ModalIndication.openDialog('create')
    },
    switchView (obj) {
      console.log('switchView', obj)
      this.mode = obj.value
      this.textModeView = obj.label
    },
    getNameClass (status) {
      if (status === 1) return 'bg-red-600' // Có kết luận nhưng chưa đánh dấu đã xem
      else if (status === 2) return 'bg-yellow-800' // Đã xem CS
      else if (status === 3) return 'bg-green-600' // Đã xem NCS
      else return 'bg-gray-400' // Chưa có kết luận
    },
    async getIndicationsByMR () {
      try {
        const params = {
          medical_record_id: this.$route.params.id,
          limit: 500,
          sort: 'created_at',
          sort_by: 'desc'
        }
        this.loading = true
        const resp = await this.$rf.getRequest('DoctorRequest').getIndicationsByMR(params)
        this.dataState = resp?.data.map(item => {
          return { ...item, valueStatus: this.setStatusDefault(item) }
        })
        this.loading = false
      } catch (error) {
        console.log(error)
      }
    },
    getDataDemo (id) {
      return id ? this.dataDemo[id - 1].name : 'Chưa chọn nơi thực hiện'
    },
    formatDMY (date) {
      return date && moment(date).format('DD-MM-YYYY')
    },
    checkType (checklist) {
      return checklist.examination_results?.type
    },
    setValueStatus (option) {
      if (!option?.value) return
      if (confirm('Bạn chắc chắn muốn đổi trạng thái.')) this.updateStatusIndication(option?.id, option?.value)
    },
    setStatusDefault (obj) {
      if (obj?.status === 2) return this.optionsStatus[1].label
      else if (obj?.status === 3) return this.optionsStatus[2].label
      else return this.optionsStatus[0].label
    },
    async updateStatusIndication (id, status) {
      if (!id) return
      const params = {
        status
      }
      await this.$rf.getRequest('DoctorRequest').updateStatusIndication(id, params)
        .then(res => {
          this.getIndicationsByMR()
          this.$message({
            message: 'Thay đổi trạng thái thành công',
            type: 'success'
          })
        })
        .catch(error => {
          console.log('updateStatusIndication', error)
          this.$message({
            message: 'Thay đổi trạng thái thất bại',
            type: 'error'
          })
        })
    },
    setOptionStatus (option, id) {
      return { ...option, id }
    }
  }
}
</script>
  
<style lang="scss" scoped>
::v-deep {
  .checklist-item {
    width: 320px;
    background-color: white;
    border: 1px solid #e3e3e3;
    border-radius: 10px;
    padding: 12px;
    margin-bottom: 12px;
    position: relative;
  }
  .border-item-dashed {
    border: 1px dashed #c3c3c3;
  }
  .h-item-scroll {
    overflow-y: auto;
    height: 60vh;
  }
  .checklist-icon {
    width: 18px;
    height: 18px;
  }
  .el-button.btn-dropdown {
    min-width: 100px;
    padding: 8px 10px;
  }
}
</style>
